/* UTVX — graphical navigation behaviour (desktop mega menu + mobile drawer panels) */
(function () {
  'use strict';
  if (window.__utvxNav) return;
  window.__utvxNav = true;

  var d = document;
  var KEY = 'utvw_garage_v1';
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function $$(sel, el) { return Array.prototype.slice.call((el || d).querySelectorAll(sel)); }

  /* ---------------- lazy images ---------------- */
  function hydrate(root) {
    $$('img[data-src]', root).forEach(function (img) {
      if (img.getAttribute('data-srcset')) img.setAttribute('srcset', img.getAttribute('data-srcset'));
      img.setAttribute('src', img.getAttribute('data-src'));
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    });
  }

  /* ---------------- garage ---------------- */
  function readGarage() {
    try {
      var g = JSON.parse(localStorage.getItem(KEY));
      if (g && Array.isArray(g.list)) return g;
    } catch (e) {}
    return { list: [], active: null };
  }
  function activeVehicle() {
    var g = readGarage();
    if (!g.list.length) return null;
    var v = null;
    if (g.active !== null && g.active !== undefined) {
      if (typeof g.active === 'number') v = g.list[g.active] || null;
      if (!v) {
        for (var i = 0; i < g.list.length; i++) {
          var x = g.list[i];
          if (x && (x.k + '|' + x.y === g.active || x.k === g.active)) { v = x; break; }
        }
      }
    }
    v = v || g.list[0];
    if (!v || !v.k) return null;
    var V = window.UTVW_VEHICLES || [];
    var info = null;
    for (var j = 0; j < V.length; j++) { if (V[j].k === v.k) { info = V[j]; break; } }
    return {
      k: v.k,
      y: v.y,
      mk: info ? info.mk : '',
      md: info ? info.md : v.k.replace(/-/g, ' '),
      url: ROOT + 'collections/' + v.k + '-accessories' + (v.y ? '?yr=' + encodeURIComponent(v.y) : '')
    };
  }
  function slug(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }

  function paintGarage() {
    var v = activeVehicle();
    $$('[data-utvx-garage]').forEach(function (card) {
      var lbl = card.querySelector('[data-g-lbl]');
      var veh = card.querySelector('[data-g-veh]');
      var shop = card.querySelector('[data-g-shop]');
      var btn = card.querySelector('[data-g-btn]');
      if (v) {
        card.classList.add('is-set');
        lbl.textContent = 'Your ride';
        veh.textContent = [v.y, v.mk, v.md].filter(Boolean).join(' ');
        shop.href = v.url;
        shop.hidden = false;
        btn.textContent = 'Change';
      } else {
        card.classList.remove('is-set');
        lbl.textContent = 'My Garage';
        veh.textContent = 'Add your ride';
        shop.hidden = true;
        btn.textContent = 'Add vehicle';
      }
    });
    $$('[data-ux-k]').forEach(function (a) {
      a.classList.toggle('is-mine', !!v && a.getAttribute('data-ux-k') === v.k);
    });
    return v;
  }

  /* ---------------- desktop mega menu ---------------- */
  function initDesktop(nav) {
    var items = $$('[data-ux-item]', nav);
    var open = null;
    var tOpen = null;
    var tClose = null;
    var openScrollY = 0;
    var overlay = d.createElement('div');
    overlay.className = 'ux-overlay';
    overlay.setAttribute('aria-hidden', 'true');
    d.body.appendChild(overlay);

    function headerBottom() {
      var hw = nav.closest('.header-wrapper') || nav.closest('header') || nav;
      return Math.max(0, Math.round(hw.getBoundingClientRect().bottom));
    }
    function place() {
      var top = headerBottom();
      overlay.style.setProperty('--ux-top', top + 'px');
      nav.style.setProperty('--ux-top', top + 'px');
    }
    function setOpen(item, focusFirst) {
      if (open === item) return;
      var switching = !!(open && item);
      if (open) {
        open.classList.remove('is-open');
        open.querySelector('[data-ux-trigger]').setAttribute('aria-expanded', 'false');
      }
      open = item;
      if (!item) {
        overlay.classList.remove('is-on');
        nav.classList.remove('ux-has-open');
        return;
      }
      var panel = item.querySelector('[data-ux-panel]');
      hydrate(panel);
      nav.classList.toggle('is-switching', switching);
      place();
      item.classList.add('is-open');
      item.querySelector('[data-ux-trigger]').setAttribute('aria-expanded', 'true');
      nav.classList.add('ux-has-open');
      overlay.classList.add('is-on');
      openScrollY = window.scrollY;
      if (switching) requestAnimationFrame(function () { requestAnimationFrame(function () { nav.classList.remove('is-switching'); }); });
      if (focusFirst) {
        var f = panel.querySelector('a[href], button');
        if (f) f.focus();
      }
    }
    function close(returnFocus) {
      clearTimeout(tOpen);
      clearTimeout(tClose);
      var cur = open;
      setOpen(null);
      if (returnFocus && cur) cur.querySelector('[data-ux-trigger]').focus();
    }

    items.forEach(function (item) {
      var trig = item.querySelector('[data-ux-trigger]');
      item.addEventListener('mouseenter', function () {
        if (!canHover.matches) return;
        clearTimeout(tClose);
        clearTimeout(tOpen);
        tOpen = setTimeout(function () { setOpen(item); }, open ? 40 : 110);
      });
      item.addEventListener('mouseleave', function () {
        if (!canHover.matches) return;
        clearTimeout(tOpen);
        tClose = setTimeout(function () { if (open === item) close(); }, 260);
      });
      trig.addEventListener('click', function (e) {
        e.preventDefault();
        clearTimeout(tOpen);
        clearTimeout(tClose);
        if (open === item) close(); else setOpen(item);
      });
      trig.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); setOpen(item, true); }
      });
    });

    // plain links: hovering them closes any open panel
    $$('.ux-nav__item:not([data-ux-item])', nav).forEach(function (li) {
      li.addEventListener('mouseenter', function () {
        if (!canHover.matches || !open) return;
        clearTimeout(tOpen);
        tClose = setTimeout(close, 120);
      });
    });

    overlay.addEventListener('click', function () { close(); });
    overlay.addEventListener('mouseenter', function () { if (canHover.matches && open) { clearTimeout(tClose); tClose = setTimeout(close, 160); } });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && open) close(true); });
    d.addEventListener('click', function (e) { if (open && !nav.contains(e.target)) close(); });
    nav.addEventListener('focusout', function (e) {
      if (open && e.relatedTarget && !nav.contains(e.relatedTarget)) close();
    });
    window.addEventListener('scroll', function () {
      if (!open) return;
      if (Math.abs(window.scrollY - openScrollY) > 140) close(); else place();
    }, { passive: true });
    window.addEventListener('resize', function () { if (open) place(); });

    // make tabs (vehicles)
    $$('[data-ux-tabs]', nav).forEach(function (wrap) {
      var tabs = $$('[data-ux-tab]', wrap);
      var t = null;
      function act(id) {
        tabs.forEach(function (x) {
          var on = x.getAttribute('data-ux-tab') === id;
          x.classList.toggle('is-active', on);
          x.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        $$('[data-ux-pane]', wrap).forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-ux-pane') === id);
        });
      }
      wrap.__uxAct = act;
      tabs.forEach(function (tab) {
        var id = tab.getAttribute('data-ux-tab');
        tab.addEventListener('mouseenter', function () {
          if (!canHover.matches) return;
          clearTimeout(t);
          t = setTimeout(function () { act(id); }, 70);
        });
        tab.addEventListener('mouseleave', function () { clearTimeout(t); });
        tab.addEventListener('focus', function () { act(id); });
        tab.addEventListener('click', function (e) {
          if (!tab.classList.contains('is-active')) { e.preventDefault(); act(id); }
        });
        tab.addEventListener('keydown', function (e) {
          var i = tabs.indexOf(tab);
          var n = null;
          if (e.key === 'ArrowDown') n = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowUp') n = tabs[(i - 1 + tabs.length) % tabs.length];
          if (n) { e.preventDefault(); n.focus(); }
        });
      });
    });

    // category preview
    $$('[data-ux-preview-group]', nav).forEach(function (g) {
      var prev = g.querySelector('[data-ux-preview]');
      if (!prev) return;
      var imgs = $$('[data-ux-pimg]', prev);
      var title = prev.querySelector('[data-ux-ptitle]');
      var desc = prev.querySelector('[data-ux-pdesc]');
      var count = prev.querySelector('[data-ux-pcount]');
      var cats = $$('[data-ux-cat]', g);
      cats.forEach(function (a) {
        function show() {
          var key = a.getAttribute('data-ux-cat');
          imgs.forEach(function (i) { i.classList.toggle('is-on', i.getAttribute('data-ux-pimg') === key); });
          cats.forEach(function (x) { x.classList.toggle('is-hot', x === a); });
          title.textContent = a.getAttribute('data-title');
          desc.textContent = a.getAttribute('data-desc');
          count.textContent = a.getAttribute('data-count');
          prev.href = a.href;
        }
        a.addEventListener('mouseenter', show);
        a.addEventListener('focus', show);
      });
    });

    // garage: preselect the make of the saved vehicle
    function syncMake() {
      var v = paintGarage();
      if (!v) return;
      var mk = slug(v.mk) || v.k.split('-')[0];
      $$('[data-ux-tabs]', nav).forEach(function (wrap) {
        var has = wrap.querySelector('[data-ux-tab="' + mk + '"]');
        if (has && wrap.__uxAct) wrap.__uxAct(mk);
      });
    }
    syncMake();
    d.addEventListener('utvw:garage', syncMake);

    // opening the garage modal from inside the menu closes the menu
    nav.addEventListener('click', function (e) {
      if (e.target.closest('[data-utvw-open-garage]')) close();
    });

    // pre-warm images on first intent
    nav.addEventListener('pointerenter', function warm() {
      nav.removeEventListener('pointerenter', warm);
      setTimeout(function () { $$('[data-ux-panel]', nav).forEach(hydrate); }, 400);
    });
  }

  /* ---------------- mobile / tablet drawer ---------------- */
  function initMobile(root) {
    var stack = ['root'];
    function scroller() {
      var el = root.parentElement;
      while (el && el !== d.body) {
        var oy = getComputedStyle(el).overflowY;
        if ((oy === 'auto' || oy === 'scroll') && el.scrollHeight > el.clientHeight) return el;
        el = el.parentElement;
      }
      return null;
    }
    function show(id, back) {
      var cur = root.querySelector('.utvm-panel.is-active');
      var next = root.querySelector('[data-utvm-panel="' + id + '"]');
      if (!next || next === cur) return;
      if (cur) cur.classList.remove('is-active', 'from-left', 'from-right');
      next.classList.remove('from-left', 'from-right');
      void next.offsetWidth;
      next.classList.add('is-active', back ? 'from-left' : 'from-right');
      var sc = scroller();
      if (sc) sc.scrollTop = 0;
      var focusEl = next.querySelector('[data-utvm-back]') || next.querySelector('a[href]');
      if (focusEl) { try { focusEl.focus({ preventScroll: true }); } catch (e) { focusEl.focus(); } }
    }
    function go(id) { stack.push(id); show(id); }
    function back() { if (stack.length > 1) stack.pop(); show(stack[stack.length - 1], true); }
    function reset() { stack = ['root']; show('root', true); }

    root.addEventListener('click', function (e) {
      var g = e.target.closest('[data-utvm-go]');
      if (g && root.contains(g)) { e.preventDefault(); go(g.getAttribute('data-utvm-go')); return; }
      var b = e.target.closest('[data-utvm-back]');
      if (b && root.contains(b)) { e.preventDefault(); back(); return; }
    });
    root.addEventListener('keydown', function (e) {
      if (e.key !== ' ') return;
      var t = e.target.closest('[role="button"]');
      if (t && root.contains(t)) { e.preventDefault(); t.click(); }
    });

    // garage button inside the drawer: close drawer first, keep the page from jumping
    root.addEventListener('click', function (e) {
      var gb = e.target.closest('[data-utvw-open-garage]');
      if (!gb || !root.contains(gb)) return;
      e.preventDefault();
      var hd = root.closest('header-drawer');
      if (hd && typeof hd.closeMenuDrawer === 'function') {
        try { hd.closeMenuDrawer(e, hd.querySelector('summary')); } catch (err) {}
      }
    }, true);

    var det = root.closest('details');
    if (det) {
      det.addEventListener('toggle', function () {
        if (!det.open) setTimeout(reset, 350);
      });
    }

    // jump straight to the saved vehicle's make
    function syncMine() {
      var v = paintGarage();
      if (!v) return;
      var mk = slug(v.mk) || v.k.split('-')[0];
      var rail = root.querySelector('.utvm-rail');
      var card = root.querySelector('.utvm-mk[data-utvm-go="make-' + mk + '"]');
      if (rail && card && card.parentNode === rail && rail.firstElementChild !== card) rail.insertBefore(card, rail.firstElementChild);
    }
    syncMine();
    d.addEventListener('utvw:garage', syncMine);
  }

  function init() {
    $$('[data-ux-nav]').forEach(function (n) { if (!n.__ux) { n.__ux = 1; initDesktop(n); } });
    $$('[data-utvm]').forEach(function (m) { if (!m.__ux) { m.__ux = 1; initMobile(m); } });
    paintGarage();
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
  // theme editor re-renders the header section
  d.addEventListener('shopify:section:load', function () { window.__utvxNav && init(); });
  window.addEventListener('storage', function (e) { if (e.key === KEY) paintGarage(); });
})();
